"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _TableCell = _interopRequireDefault(require("react-base-table/es/TableCell"));

var _utils = require("react-base-table/es/utils");

var _exportToCsvFixSourceMap = require("export-to-csv-fix-source-map");

var _utils2 = require("./utils");

var _actions = require("./actions");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var exportTableToCsv = function exportTableToCsv(columns, data, csvFileName, onExportCSV, fireAction, onToastHandler, enableCSVToastMessage) {
  var rowsData = (0, _toConsumableArray2["default"])(data);
  var totalRows = data.length;
  var totalChunkRows = [];
  var headers = (0, _map["default"])(columns).call(columns, function (col) {
    return (0, _utils2.isString)(col.csvTitle) ? col.csvTitle : (0, _utils2.isString)(col.title) ? col.title : "";
  });

  function extractContent(value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent;
    return text;
  }

  var sanitizeCellValue = function sanitizeCellValue(value) {
    var injectionVulnerableRegex = /^[=@+-]/;
    var sanitizedCell = typeof value === "string" && injectionVulnerableRegex.test(value) ? "'".concat(value) : value;
    return sanitizedCell;
  };

  var getCSVData = function getCSVData(dataValue) {
    return (0, _map["default"])(dataValue).call(dataValue, function (rowData, rowIndex) {
      var row = {};
      (0, _forEach["default"])(columns).call(columns, function (column, columnIndex) {
        var dataGetter = column.dataGetter,
            dataKey = column.dataKey,
            cellRenderer = column.cellRenderer,
            key = column.key,
            getCsvValue = column.getCsvValue;
        var cellData = dataGetter ? dataGetter({
          columns: columns,
          column: column,
          columnIndex: columnIndex,
          rowData: rowData,
          rowIndex: rowIndex
        }) : (0, _utils.getValue)(rowData, dataKey);
        var cellProps = {
          cellData: cellData,
          columns: columns,
          column: column,
          columnIndex: columnIndex,
          rowData: rowData,
          rowIndex: rowIndex
        };
        var cell = (0, _utils.renderElement)(getCsvValue || cellRenderer || /*#__PURE__*/_react["default"].createElement(_TableCell["default"], null), cellProps);
        row[key] = sanitizeCellValue( /*#__PURE__*/(0, _react.isValidElement)(cell) ? extractContent(_server["default"].renderToString(cell)) : cell);
      });
      return row;
    });
  };

  var options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useTextFile: false,
    useBom: true,
    filename: csvFileName,
    headers: headers
  };
  var csvExporter = new _exportToCsvFixSourceMap.ExportToCsv(options);

  function runTaskQueue(deadline) {
    while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && rowsData.length) {
      // make list into smaller chunks
      for (var i = 0; i < rowsData.length; i += 1000) {
        if (deadline.timeRemaining() > 0) {
          var _context;

          var chunk = (0, _splice["default"])(rowsData).call(rowsData, i, 1000);
          totalChunkRows = (0, _concat["default"])(_context = []).call(_context, (0, _toConsumableArray2["default"])(totalChunkRows), (0, _toConsumableArray2["default"])(getCSVData(chunk)));
        }
      }

      if (totalRows === totalChunkRows.length) {
        csvExporter.generateCsv(totalChunkRows);
      }
    }

    if (rowsData.length > 0) {
      requestIdleCallback(runTaskQueue);
    }
  }

  function handleIdleDeadline() {
    var totalRowsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : data;
    rowsData = (0, _toConsumableArray2["default"])(totalRowsData);
    var intervalID = (0, _setInterval2["default"])(function () {
      if (rowsData.length > 0) {
        var _context2;

        var chunk = (0, _splice["default"])(rowsData).call(rowsData, 0, 1000);
        totalChunkRows = (0, _concat["default"])(_context2 = []).call(_context2, (0, _toConsumableArray2["default"])(totalChunkRows), (0, _toConsumableArray2["default"])(getCSVData(chunk)));
      } else {
        clearInterval(intervalID);

        if (totalRowsData.length === totalChunkRows.length) {
          csvExporter.generateCsv(totalChunkRows);
        }
      }
    }, 300);
  }

  if ((0, _utils2.isFunction)(onExportCSV)) {
    var promise = onExportCSV();

    if (promise instanceof _promise["default"]) {
      promise.then(function (csvResults) {
        rowsData = (0, _toConsumableArray2["default"])(csvResults);
        totalRows = rowsData.length;
        onToastHandler(enableCSVToastMessage);

        if (window.requestIdleCallback) {
          requestIdleCallback(runTaskQueue);
        } else {
          // Fallback for browsers which don't support requestIdleCallback
          (0, _setTimeout2["default"])(function () {
            handleIdleDeadline(rowsData);
          }, 300);
        }
      })["catch"](function (error) {
        throw new Error(error);
      })["finally"](function () {
        fireAction((0, _actions.isTableBusy)(false));
      });
    }
  } else {
    onToastHandler(enableCSVToastMessage);

    if (window.requestIdleCallback) {
      requestIdleCallback(runTaskQueue);
    } else {
      // Fallback for browsers which don't support requestIdleCallback
      (0, _setTimeout2["default"])(function () {
        handleIdleDeadline();
      }, 300);
    }

    fireAction((0, _actions.isTableBusy)(false));
  }
};

var _default = exportTableToCsv;
exports["default"] = _default;